<template>
  <div class="sun full SectionProcess">
    <div class="title">
      <b>1분 간편 한도 조회</b><br/>
      신청 다음 날부터 사용 가능!
    </div>
    <div class="process1">
      <div class="process2">
        <div class="process">
          <div class="blank"></div>
          <div class="phone slow" v-if="steps" v-inview:animate="'fadeInUp'">
            <div class="img" v-for="(step, index) in steps" :key="'image'+index">
              <img class="slow" :src="require('@/assets/images/main/SectionProcess/'+step.img)" v-if="indexCurrent==index" v-inview:animate="'fadeIn'"/>
            </div>
          </div>
          <div class="steps" v-if="steps">
            <a class="step" v-for="(step, index) in steps" :key="'btn'+index" @click="setIndexCurrent(index)">
              <div class="number">
                <div class="circle" v-html="index+1" :style="{backgroundColor: indexCurrent==index?'#1baaf1':'#8a94a2'}"></div>
              </div>
              <div class="text" v-html="step.title" :style="{color: indexCurrent==index?'#1baaf1':'#8a94a2'}"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      온라인 신청 과정이 불편하신 분들을 위해<br/>
      펀다 멤버들이 유선/방문을 통해 도와드리고 있어요!
    </div>
  </div>
</template>

<script>
let self

export default {
  name: 'SectionProcess',
  components: {
  },
  props: {},
  data: function () {
    return {
      indexCurrent: 0,
      steps: [
        { title: '로그인 후<br/>한도조회(1분)', img: 'app1.png' },
        { title: '온라인<br/>접수완료(1분)', img: 'app2.png' },
        { title: '통장개설<br/>계약서 작성(3분)', img: 'app3.png' },
        { title: '마이너스 통장<br/>사용(다음 날)', img: 'app4.png' },
      ]
    }
  },
  computed: {
    imgCurrent: function () {
      if (!this.steps) return
      return this.steps[this.indexCurrent].img
    }
  },
  async created() {
    self = this
    if (this.interval) { clearInterval(this.interval) }
    this.interval = setInterval(function () {
      self.indexCurrent = (self.indexCurrent + 1) % self.steps.length
    }, 4000)
  },
  destroyed() {},
  methods: {
    setIndexCurrent: function (index) {
      if (this.interval) { clearInterval(this.interval) }
      this.indexCurrent = index
    }
  },
}
</script>

<style lang="scss" scoped>
  .SectionProcess {
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;
    float: left;
    .title {
      font-weight: 500;
      font-size: 25px;
      line-height: 1.4;
      letter-spacing: -0.79px;
      text-align: center;
      color: #333333;
      width: 100%;
      b {
        font-weight: 800;
      }
    }
    .process1 {
      width: 100%;
      padding-top: calc(350% / 375 * 100);
      margin-top: 41px;
      .process2 {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        overflow: hidden;
      }
    }

    .process {
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .blank{
        width: calc(20% / 375 * 100);
        height: 100%;
      }
      .phone{
        width: calc(211% / 375 * 100);
        margin-top: 9px;
        height: calc(100% - 9px);
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        box-shadow: 6px 12px 24px 0 rgba(0, 0, 0, 0.14);
        background-color: #ffffff;

        .img {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          img {
            margin-top: 30px;
            width: calc(100% - 8px);
          }
        }
      }
      .steps{
        width: calc(144% / 375 * 100);
        height: 100%;
        display: flex;
        flex-direction: column;
        .step {
          flex: 1;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .number {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            .circle {
              width: 26px;
              height: 26px;
              border-radius: 100%;
              color: white;
              background-color: #333333;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .text {
            width: 100%;
            font-weight: 700;
            font-size: 14px;
            line-height: 1.29;
            letter-spacing: -0.44px;
            text-align: center;
            color: #727d8c;
            margin-top: 5px;
          }
        }
      }
    }
    .content {
      width: 100%;
      font-weight: 500;
      font-size: 15px;
      line-height: 1.6;
      letter-spacing: -0.27px;
      text-align: center;
      color: #727d8c;
      margin-top: 18px;
    }
  }
</style>
